<template>
  <div class="po-a home" :style="{ 'background-image': `url(${baseUrl}images/login-bg.png)` }">
    <div class="po-a bg-w login-card">
      <div class="po-a login-logo">
        <img :src="`${baseUrl}images/logo.png`">
      </div>
      <p class="w100 font-24 tx-c red">欢迎登录</p>
      <el-row>
        <el-col class="mt20" :span="24">
          <el-input size="large" placeholder="用户名" type="text" v-model="username" :disabled="loading" suffix-icon="myfont icon-zhanghao" @keyup.enter.native="logining"></el-input>
        </el-col>
        <el-col class="mt20" :span="24">
          <el-input size="large" placeholder="密码" type="password" v-model="password" :disabled="loading" suffix-icon="myfont icon-zhanghaomima" @keyup.enter.native="logining"></el-input>
        </el-col>
        <el-col class="mt10 red tx-c" :span="24" v-if="error != ''">
          {{ error }}
        </el-col>
        <el-col class="mt20" :span="24">
          <el-button class="w100" size="large" round type="danger" :disabled="username == '' || password == ''" :loading="loading" @click="logining">登 录</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
  <!-- <div></div> -->
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "login",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,

      uip: "",
      username: "",
      password: "",
      remember: false,
      error: ""
    };
  },
  computed: {
    ...mapState(["userToken", "userLoading"])
  },
  created() {
  },
  mounted() {},
  methods: {
    ...mapActions(["fetchUserData", "setUserToken"]),
    logining() {
      if (this.username == "" || this.password == "") {
        return;
      }

      this.loading = true;
      this.$http
        .post(
          `web/login`,
          this.$qs.stringify({
            deviceType: "pc",
            username: this.username,
            password: this.password
          })
        )
        .then(({ data }) => {
          if (data.RetStatus == 0 && data.RetCode) {
            // window.localStorage.setItem('userToken', data.RetData);
            window.sessionStorage.setItem("userToken", data.RetData.sid);
            document.cookie = data.RetData.cookie;

            // this.setUserToken(data.RetData);
            this.setUserToken(data.RetData.sid)
              .then(() => {
                this.fetchUserData();
                this.$router.push({ name: "home" });
              })
              .catch(() => {
                this.error = "设置用户信息失败";
              });
          } else {
            this.error = data.RetMsg;
          }

          this.loading = false;
        })
        .catch(() => {
          this.error = "网络请求出错，请检查网络";
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.home {
  width: 100%;
  height: 100%;
  background: no-repeat center bottom;
  background-size: cover;
}

.login-card {
  right: 20%;
  top: 50%;
  transform: translate(0, -50%);
  padding: 40px;
  width: 360px;
  border-radius: 8px;
}

.login-logo {
  left: -95px;
  top: -100px;
}
</style>

